import ProjectTable from "./components/ProjectTable"


const ProjectList = ({reloadList})=>{
    return (
        <div >
            <ProjectTable reloadList={reloadList}/>
        </div>
    )
}

export default ProjectList